import { render } from "./WebcamBox.vue?vue&type=template&id=79bf086d"
import script from "./WebcamBox.vue?vue&type=script&lang=ts"
export * from "./WebcamBox.vue?vue&type=script&lang=ts"

import "./WebcamBox.vue?vue&type=style&index=0&id=79bf086d&lang=scss"
script.render = render

export default script